import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../../../../styles/themes/vad/constants';
const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#ffffff',
    maxWidth: '614px',
    width: '100%',
    transition: 'ease 1s all',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },

    '& .passportToastWrapper': {

      '& .passportToastContentWrapper': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        '& .crossButton': {
          minWidth: 'auto',
          width: '36px',
          height: '36px',
          backgroundColor: '#f7f7f7',
          borderRadius: '50%',
          border: '2px solid #fff',
          [theme.breakpoints.down('md')]: {
            width: '28px',
            height: '28px',
          },

          '& .MuiCircularProgress-root': {
            position: 'absolute',
            transform: 'rotate(-90Deg) !important',
            color: '#FF8707',
            opacity: '0.7',
            width: '28px !important',
            height: '28px !important',
            [theme.breakpoints.down('md')]: {
              width: '28px !important',
              height: '28px !important',
            },

            '& .MuiCircularProgress-svg': {

              '& circle': {
                strokeWidth: '2px'
              }
            }
          }
        },
        '& .passportToastBtn': {
          background: 'transparent',
          border: '1px solid #FF8707',
          ...theme.mixins.marginLeft(pxToRem(48)),
          [theme.breakpoints.down('md')]: {
            width: '100%',
            minWidth: pxToRem(240),
          },
          [theme.breakpoints.down('sm')]: {
            marginTop: pxToRem(12),
            ...theme.mixins.marginLeft('auto'),
          },

          '& .btn-txt': {
            color: '#FF8707',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '16px'
          },

          '& .MuiButton-endIcon': {
            marginLeft: '8px !important',

            '& .material-icons': {
              display: 'flex',

              '& svg': {
                color: '#FF8707',
                width: '15px',
                height: '12px',
                '[dir="rtl"] &': {
                  transform: 'rotate(180Deg)'
                },
              },
            },
          }
        },

        '& .MuiButton-containedSizeSmall': {
          padding: `${pxToRem(9)} ${pxToRem(16)}`,
        },

        '& .passportToastInnerWrapper': {
          display: 'flex',
          flexDirection: 'column',

          '& .textTitle': {
            color: '#000000',
            fontFamily: theme.custom.fontFamily.primaryBold,
            fontSize: pxToRem(16),
            lineHeight: pxToRem(24),
          },

          '& .abuDhabiPassportLink': {

            '& .arrowForwardIcon': {
              width: '4px',
              height: '8px',
              '[dir="rtl"] &': {
                transform: 'rotate(180deg)'
              }
            },

            '& .linkLabelText': {
              ...theme.mixins.marginRight(6),
              fontSize: pxToRem(14),
              color: '#009086',
              fontFamily: theme.custom.fontFamily.primaryRegular,
              lineHeight: pxToRem(16),
              [theme.breakpoints.down('md')]: {
                lineHeight: pxToRem(24),
              },
              '&:hover': {
                textDecoration: 'underline',
              },
            },
          }
        }
      },

    },
  },
}));

export default useStyles;